import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideAuth0 } from '@auth0/auth0-angular';
import { environment } from '../environments/environment';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ErrorHttpInterceptorFn, IdTokenHttpInterceptorFn } from '@core/interceptors';
import { provideHighcharts } from 'highcharts-angular';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideAuth0(environment.authConfig),
    provideHttpClient(withInterceptors([IdTokenHttpInterceptorFn, ErrorHttpInterceptorFn])),
    provideHighcharts(),
  ],
};
